const E408 = () => (
  <div className="error-container error-408">
    <h1>408</h1>
    <p className="title">Request Timeout</p>
    <p>The request took too long to process. Please try again.</p>
  </div>
);

export default E408;
